import { noteNameToMidi } from "./chordUtils";
import { Register, midiToNote, noteToMidi } from "./registerVoicing";

const stripOctave = (note: string): string => note.replace(/-?\d+$/, "");

const notePitchClass = (note: string): number =>
  noteNameToMidi(stripOctave(note), 4) % 12;

export const expandDroneNotesToRegister = (
  droneNotes: string[],
  register?: Register
): string[] => {
  const normalizedNotes = droneNotes.map(stripOctave);
  if (!register || normalizedNotes.length === 0) {
    return normalizedNotes;
  }

  const bottomMidi = noteToMidi(register.bottomNote);
  const topMidi = noteToMidi(register.topNote);
  const midiValues = new Set<number>();

  normalizedNotes.forEach((note) => {
    const pitchClass = notePitchClass(note);
    const startOffset = (pitchClass - (bottomMidi % 12) + 12) % 12;
    let currentMidi = bottomMidi + startOffset;

    while (currentMidi <= topMidi) {
      midiValues.add(currentMidi);
      currentMidi += 12;
    }
  });

  return Array.from(midiValues)
    .sort((a, b) => a - b)
    .map((midi) => midiToNote(midi));
};
